import { apiRequest } from "../utils/useAPIRequest";
import constant from "../utils/constant";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { queryClient } from "../App";

const useGetBusinessCategories = (
  businessCategoryTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${businessCategoryTableQuery}&${filterQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${businessCategoryTableQuery}&${filterQuery}`;
    } else {
      return businessCategoryTableQuery;
    }
  }, [filterQuery, businessCategoryTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getBusinessCategories", query],
    queryFn: () => {
      return apiRequest({
        url: `/business-categories?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const createBusinessCategories = async (payload) => {
  const { status, errorMessage } = await apiRequest({
    url: "/business-categories/businessCategory",
    method: "post",
    payload: payload,
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getBusinessCategories"],
    });
    return { status };
  }
  return { status, errorMessage };
};

const editBusinessCategories = async (payload, id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/business-categories/businessCategory/${id}`,
    method: "put",
    payload: payload,
  });

  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getBusinessCategories"],
    });
    return { status };
  }
  return { status, errorMessage };
};

const deleteBusinessCategories = async (id) => {
  const { status, errorMessage } = await apiRequest({
    url: `/business-categories/businessCategory/${id}`,
    method: "delete",
  });
  if (status === constant.Success) {
    queryClient.invalidateQueries({
      queryKey: ["getBusinessCategories"],
    });
    return { status };
  }
  return { status, errorMessage };
};

export default {
  createBusinessCategories,
  editBusinessCategories,
  deleteBusinessCategories,
  useGetBusinessCategories,
};
